import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserTypeGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const userRole = this.userService.getLoggedUser()?.type ?? JSON.parse(localStorage.getItem('userRole'));

    if (userRole && !route.data.allowedTypes.includes(userRole)) {
      this.router.navigate(['dashboard']);
      return false;
    }
    return true;
  }

}
